// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"5ae6caf9","213":"867a373f","415":"2a11beb7","453":"b3f63cde","455":"aabe5ae7","937":"a9dab43a"}[chunkId] + ".chunk.js";
};